/**
 * Importation des libs
 **/
import 'greensock';
import SimpleLightbox from "simplelightbox";

/**
 * Importation des modules
 **/
import "./modules/utilities/barba";
import "./modules/utilities/locootiveScroll";
import "./modules/components/navigation";
import "./modules/components/upload_file";
import "./modules/components/equipe_popup";
import "./modules/components/customCursor";
import "./modules/components/lightbox";
import "./modules/components/builder_tabs";
import "./modules/components/builder_collapse";

/**
 * À VOIR
 */

var vid = $('.c-hero__video video');
vid.playbackRate = 0.0167;


setTimeout(function () {
    //  $('#musicplayer').play();
}, 500);
